// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { B300, B400, N0, N200, N600, N800 } from '@atlaskit/theme/colors';
import { READING_AIDS_DIALOG_WIDTH } from '../../../constants';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var InfoLink = styled.a({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
  color: "".concat("var(--ds-text-accent-blue, ".concat(B300, ")"), " !important"),
  textDecoration: 'underline'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerResultSection = styled.div(
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref) {
  var isReadingAids = _ref.isReadingAids,
    isExpanded = _ref.isExpanded;
  return isReadingAids ? {
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-accent-gray-bolder, ".concat(N800, ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    maxWidth: "calc(".concat(READING_AIDS_DIALOG_WIDTH, " - 40px)"),
    maxHeight: isExpanded ? 'fit-content' : '120px',
    overflowY: 'hidden'
  } : {
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-accent-gray, ".concat(N600, ")"),
    overflowY: 'auto',
    width: '100%'
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerResultBlurSection = styled.div({
  background: "linear-gradient( 180deg, ".concat("var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0))", " 0%, ", "var(--ds-surface-overlay, ".concat(N0, ")"), " 100% )"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  width: "calc(".concat(READING_AIDS_DIALOG_WIDTH, " - 48px)"),
  display: 'flex',
  justifyContent: 'end',
  position: 'absolute',
  top: '138px',
  cursor: 'pointer',
  paddingBottom: "var(--ds-space-050, 8px)",
  paddingTop: "var(--ds-space-200, 16px)",
  color: "var(--ds-text, #172B4D)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export var AIAnswerResultBlurSectionText = styled.div({
  display: 'flex',
  justifyContent: 'end',
  background: "linear-gradient( 90deg, ".concat("var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0))", " 0%, ", "var(--ds-surface-overlay, ".concat(N0, ")"), " 100% )"),
  width: '75%',
  paddingRight: "var(--ds-space-050, 4px)",
  font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var DisclaimerSectionWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: "var(--ds-space-075, 6px)",
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  gap: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var DisclaimerWrapper = styled.div({
  display: 'flex',
  fontStyle: 'italic'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var PermissionLabelWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: "var(--ds-space-050, 4px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  svg: {
    width: '16px',
    height: '16px'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerSourcesWrapper = styled.div({
  width: '100%',
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  button: {
    marginTop: "var(--ds-space-075, 6px)",
    maxWidth: 'fit-content',
    fontWeight: "var(--ds-font-weight-regular, 400)"
  }
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref2) {
  var isReadingAids = _ref2.isReadingAids;
  return isReadingAids ? "\n    margin-top: ".concat("var(--ds-space-100, 8px)", ";\n    h2 ~ a {\n      text-decoration: none !important;\n    }\n    ") : "\n    margin-top: ".concat("var(--ds-space-150, 12px)", ";\n    ");
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerSource = styled.div({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center'
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref3) {
  var isReadingAids = _ref3.isReadingAids;
  return isReadingAids ? "\n    &:hover,\n    &:focus-within {\n      background-color: ".concat("var(--ds-surface-hovered, #F1F2F4)", ";\n    }\n    &:active {\n      background-color: ", "var(--ds-surface-pressed, #DCDFE4)", ";\n    }\n      border-radius: 3px;\n      padding: ", "var(--ds-space-050, 4px)", ";\n    ") : "\n      padding:\n        ".concat("var(--ds-space-050, 4px)", "\n        ", "var(--ds-space-0, 0px)", "\n        ", "var(--ds-space-050, 4px)", "\n        ", "var(--ds-space-025, 2px)", ";\n      &&:last-of-type {\n        padding-bottom: ", "var(--ds-space-0, 0px)", ";\n      }\n      ");
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerSourceTitle = styled.span({
  display: 'flex',
  flexGrow: 2,
  maxWidth: '50%',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  span: {
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    a: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
      textDecorationColor: "".concat("var(--ds-text-accent-blue, ".concat(B400, ")"), " !important"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'span:first-of-type': {
        marginRight: "var(--ds-space-050, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
          height: '16px !important',
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
          width: '16px !important'
        }
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'span:last-of-type': {
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: "var(--ds-text-accent-blue, ".concat(B400, ")")
      }
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerSourceMetadata = styled.span({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '50%',
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  span: {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
      height: '16px',
      width: '16px',
      margin: "var(--ds-space-025, 2px)"
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerSourceSeparator = styled.span({
  margin: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerSourceSpaceName = styled.span({
  minWidth: 0,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  a: {
    display: 'inherit',
    cursor: 'pointer',
    color: "var(--ds-text-subtlest, ".concat(N200, ")"),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&:hover': {
      color: "var(--ds-text-subtlest, ".concat(N200, ")")
    },
    '&:visited': {
      color: "var(--ds-text-subtlest, ".concat(N200, ")")
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerSourceExpandCollapseLink = styled.div({
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  paddingBottom: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerCloseLabelWrapper = styled.div({
  display: 'flex',
  gap: "var(--ds-space-050, 4px)",
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  a: {
    cursor: 'pointer'
  }
});

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsTitleAndMetadata = styled.div({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  maxWidth: "calc(".concat(READING_AIDS_DIALOG_WIDTH, " - 72px)"),
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  flexShrink: 1,
  justifyContent: 'space-between',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  a: {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    textDecoration: 'none !important'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsSourceTitle = styled.div({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  maxWidth: "calc(".concat(READING_AIDS_DIALOG_WIDTH, " - 72px)"),
  paddingLeft: "var(--ds-space-100, 8px)",
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text-accent-gray-bolder, ".concat(N800, ")"),
  textAlign: 'left',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsSourceMetadata = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  width: "calc(".concat(READING_AIDS_DIALOG_WIDTH, " - 72px)"),
  paddingLeft: "var(--ds-space-100, 8px)",
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: "var(--ds-text-subtlest, ".concat(N200, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsIconContainer = styled.div({
  height: '24px',
  width: '24px'
});